import { gql } from 'apollo-angular';

import { PropertyMatchBean } from '@ui/shared/model';
import { allPropertySearcherFields } from './property-searcher.queries';

export const rentedFlatsApplicationsQuery = gql`
  query rentedFlatsApplications {
    rentedFlatsApplications {
      ${allPropertySearcherFields}
    }
  }
`;

export const declareIntentMutation = gql`
  mutation declareIntent($declareIntentData: DeclareIntentInput!) {
    declareIntent(input: $declareIntentData) {
      statusText
    }
  }
`;
export const revokeAllOpenApplications = gql`
  mutation revokeAllOpenApplications($input: ReasonInput!) {
    revokeAllOpenApplications(input: $input) {
      statusText
    }
  }
`;

export interface CheckApplicationExistResult {
  checkApplicationExist: { id: string; smsVerificationRequired: boolean };
}

export const checkApplicationExistQuery = gql`
  query checkApplicationExist($propertyId: ID!) {
    checkApplicationExist(propertyId: $propertyId) {
      id
      smsVerificationRequired
    }
  }
`;

export interface CreateApplicationMutationResponse {
  createApplication: PropertyMatchBean;
}

export const createApplicationMutation = gql`
  mutation createApplication(
    $userId: ID!
    $propertyId: ID!
    $captchaResponse: String
  ) {
    createApplication(
      userId: $userId
      propertyId: $propertyId
      captchaResponse: $captchaResponse
    ) {
      id
      status
      customerIdent
      property {
        customer {
          customQuestionAllowed
        }
      }
    }
  }
`;

export interface RentedFlatsApplicationsQueryResult {
  rentedFlatsApplications: PropertyMatchBean[];
}
